import React from 'react';

import ErrorView from './ErrorView';

const NotFound = () => (
  <ErrorView code={404} message={'Sorry we could not find that page'} />
);

export default NotFound;
